<template>
  <div>
    <h2 class="person-title">{{this.$t('userInfo.ChangePWD')}}</h2>
    <el-form ref="passwordForm" :model="passwordForm" :rules="rules" label-width="125px">
      <el-form-item :label="$t('userInfo.CurrentPWD')" prop="oldPass">
        <el-input type="password" v-model="passwordForm.oldPass" autocomplete="off" style="width:280px;"></el-input>
      </el-form-item>
      <el-form-item :label="$t('userInfo.NewPWD')" prop="newPass">
        <el-input type="password" v-model="passwordForm.newPass" autocomplete="off" style="width:280px;"></el-input>
      </el-form-item>
      <el-form-item :label="$t('userInfo.confirmPWD')" prop="checkPass">
        <el-input type="password" v-model="passwordForm.checkPass" autocomplete="off" style="width:280px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="submitForm('passwordForm')">{{this.$t('userInfo.Change')}}</el-button>
        <el-button type="success" plain @click="resetForm('passwordForm')">{{this.$t('userInfo.Reset')}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import axios from '@/axios'

  export default {
    name: "changePassword",
    data() {
      var validateOldPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('message.CurrentPassword')));
        } else {
          callback();
        }
      };
      var validateNewPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('message.NewPassword')));
        } else if (value === this.passwordForm.oldPass) {
          callback(new Error(this.$t('message.pwdDiffer')));
        } else {
          if (this.passwordForm.checkPass !== '') {
            this.$refs.passwordForm.validateField('checkPass');
          }
          callback();
        }
      };
      var validateCheckPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('message.pwdAgain')));
        } else if (value !== this.passwordForm.newPass) {
          callback(new Error(this.$t('message.pwdMatch')));
        } else {
          callback();
        }
      };
      return {
        passwordForm: {
          password: '',
          oldPass: '',
          newPass: '',
          checkPass: '',
          nickname: '',
          address: '',
          industry: '',
        },
        rules: {
          oldPass: [
            {validator: validateOldPass, trigger: 'blur'}
          ],
          newPass: [
            {validator: validateNewPass, trigger: 'blur'}
          ],
          checkPass: [
            {validator: validateCheckPass, trigger: 'blur'}
          ]
        }
      };

    },
    methods: {
      submitForm(passwordForm) {
        let _this = this;
        this.$refs[passwordForm].validate((valid) => {
          if (valid) {
            var oldPass = this.passwordForm.oldPass;
            var newPass = this.passwordForm.newPass;
            axios.post(this.$store.state.apiBasePath + "/user/password?" + "password=" + newPass + "&oldPassword=" + oldPass)
              .then(function (res) {
                var resData = res.data;
                if (resData.code === 200) {
                  localStorage.removeItem('loginToken');
                  localStorage.removeItem('nickname');
                  this.$message({
                    title:_this.$t('message.Success'),
                    message:_this.$t('message.changeDone'),
                    type: 'success',
                    showClose: true,
                    offset:300,
                    duration:3000,
                    onClose:function(){
                      // 退出登录，跳回首页
                      _this.$router.push('/');
                    }
                  });
                } else {
                  this.$message({
                    title: _this.$t('message.Error'),
                    message: res.data.msg,
                    offset:300,
                    duration:3000,
                  });
                }
              })
          } else {
            // console.log('error submit!!');
            return false;
          }
        });
      },


      resetForm(passwordForm) {
        this.$refs[passwordForm].resetFields();
      }
    }

  }
</script>

<style scoped>
  .person-title {
    border-bottom: #ddd 1px solid;
    padding-bottom: 10px;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/userCenter/changePassword.vue